import './bootstrap';
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createI18n } from 'vue-i18n';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/index.esm.js';
import { initPassiveEvents, passiveTouchDirective } from './utils/passiveEvents.js';

// Import debug
import './debug.js';

// Import language files
import en from './lang/en/content.js';
import th from './lang/th/content.js';

// console.log('🚀 Starting PETPAL App...');

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    th,
  },
  legacy: false,
  globalInjection: true,
});

// console.log('🌐 i18n created:', i18n);

createInertiaApp({
  title: (title) => `${title} - PETPAL`,
  resolve: (name) => {
    // console.log('📄 Resolving page:', name);
    // Handle nested paths like News/Show and add .vue extension
    const pageName = name.includes('/') ? `${name}.vue` : `${name}.vue`;
    return resolvePageComponent(`./pages/${pageName}`, import.meta.glob('./pages/**/*.vue'));
  },
  setup({ el, App, props, plugin }) {
    // console.log('⚙️ Setting up Vue app...');
    // console.log('Element:', el);
    // console.log('App:', App);
    // console.log('Props:', props);
    // console.log('Plugin:', plugin);
    
    const app = createApp({ render: () => h(App, props) });
    
    // Initialize passive events for better performance
    initPassiveEvents();
    
    // Configure Vue to use passive event listeners by default
    app.config.globalProperties.$passiveEvents = true;
    
    // Add global directive for passive touch events
    app.directive('passive-touch', passiveTouchDirective);
    
    // console.log('🔧 Adding plugins...');
    app.use(plugin);
    app.use(i18n);
    app.use(ZiggyVue);
    
    // console.log('🎯 Mounting app...');
    const mountedApp = app.mount(el);
    // console.log('✅ App mounted:', mountedApp);
    
    return mountedApp;
  },
  progress: {
    color: '#FFC72C',
  },
});
